
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preview",
      function () {
        return require("private-next-pages/preview/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preview"])
      });
    }
  